export default __webpack_public_path__ + "static/AeonikBlack-6db562b82fb47dfb6e9072c808fe9c70.eot";